import {
  deleteFirmSignatureRequestV2,
  fulfillFirmSignatureRequestPublicV2,
} from "@/lib/data/requests/firm/firm-signature-request";
import { queryKeys } from "@/lib/data/static/query-keys";
import { type APIError } from "@/lib/types";
import { toastAPIErrorMessage } from "@/lib/utils/axiosUtils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { AxiosError } from "axios";
import toast from "react-hot-toast";

export const useDeleteFirmSignatureRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteFirmSignatureRequestV2,
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error deleting firm signature request");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.firmSignatureRequests],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.firmFiles],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.signatureRequests],
      });
    },
    onSuccess: () => {
      toast.success("Firm signature request deleted successfully");
    },
  });
};

export const useFulfillFirmSignatureRequest = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fulfillFirmSignatureRequestPublicV2,
    onError: (error: AxiosError<APIError>) => {
      toastAPIErrorMessage(error, "Error fulfilling firm signature request");
    },
    onSettled: async () => {
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.signatureRequests],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.firmFiles],
      });
      await queryClient.invalidateQueries({
        queryKey: [queryKeys.firmSignatureRequests],
      });
    },
    onSuccess: () => {
      toast.success("Firm signature request fulfilled successfully");
    },
  });
};
